module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.response) ? _c('div', [(_vm.response) ? _c('document-container', {
    attrs: {
      "header": _vm.header,
      "logo": _vm.logo,
      "timeout": 3000,
      "documentType": "whitelabel"
    }
  }, [_c('chart-container', {
    attrs: {
      "slot": "raw-body",
      "chartData": _vm.chartData,
      "chartType": 'ChartReport',
      "heading": 'Kursentwicklung Produkt (' + _vm.getTimeFrame + ')',
      "settings": {
        style: {
          width: 1000,
          height: 500
        }
      }
    },
    slot: "raw-body"
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tables.tables), function(table, key) {
    return _c('document-container', {
      key: 'table-' + key,
      attrs: {
        "header": _vm.header,
        "logo": _vm.logo,
        "tables": _vm.tables,
        "timeout": 3000,
        "documentType": "whitelabel"
      }
    }, [_c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('table-whitelabel', {
      attrs: {
        "table": _vm.tables.findTable(table.id)
      }
    })], 1)])
  }), _vm._v(" "), _c('document-container', {
    attrs: {
      "documentType": "whitelabel"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h2', [_vm._v("Datenquellen")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('tr', _vm._l((_vm.response.dataSuppliers), function(img) {
    return _c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_c('img', {
      attrs: {
        "src": 'https://files.dericon.de/' + img.logo,
        "alt": "",
        "width": "100"
      }
    })])
  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.response.dataSuppliers), function(name) {
    return _c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v("\n            " + _vm._s(name.name) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('textblock', {
    attrs: {
      "data": {
        body: ["Kurse und Kennzahlen: Angezeigte Daten sind nicht in Echtzeit. Tatsächliche Konditionen können aufgrund zwischenzeitlicher Kursänderungen abweichen."]
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('textblock', {
    attrs: {
      "data": _vm.footerDisclaimer
    }
  })], 1)])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd80912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/whitelabel/Whitelabel.vue
// module id = 723
// module chunks = 0